const uriCache = new Map();

export const resolveAlias = async (href, language = 'en') => {
  try {
    if (!href) return '';

    if (href.startsWith('http://') || href.startsWith('https://')) {
      return href;
    }

    let path = href;
    if (href.startsWith('entity:')) {
      path = '/' + href.replace('entity:', '');
    }
    if (href.startsWith('internal:')) {
      path = href.replace('internal:', '');
    }

    const nodeMatch = path.match(/^\/node\/(\d+)/);
    if (!nodeMatch) return path;

    const cacheKey = `alias:${path}`;
    if (uriCache.has(cacheKey)) {
      return uriCache.get(cacheKey);
    }

    const langPrefix = language === 'es' ? '/es' : '';

    const res = await fetch(`${langPrefix}/router/translate-path?path=${encodeURIComponent(path)}`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return path;

    const data = await res.json();
    let alias = data?.alias || data?.canonical || data?.resolved;
    if (!alias) return path;

    try {
      const urlObj = new URL(alias);
      alias = urlObj.pathname || alias;
    } catch (_e) { }
    uriCache.set(cacheKey, alias);
    return alias;

  } catch (_e) {
    return href;
  }
};
